module.exports = __webpack_public_path__ + "page_4_bc.8f44c47e.png";